module.exports = __webpack_public_path__ + "static/media/4_multifiber_A_orange_square.eab4cf3b.png";